"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceClient = void 0;
const session_storage_1 = require("../storage/session-storage");
class PreferenceClient {
    constructor(preferenceHttpAdapter, preferenceParser, featureFlags, config, store) {
        var _a;
        this.preferenceHttpAdapter = preferenceHttpAdapter;
        this.preferenceParser = preferenceParser;
        this.featureFlags = featureFlags;
        this.config = config;
        this.store = store;
        this.isServerSide = typeof window === 'undefined';
        this.setStorage = this.store
            ? this.store
            : typeof window === 'undefined'
                ? undefined
                : window === null || window === void 0 ? void 0 : window.sessionStorage;
        this.storage = !this.isServerSide
            ? new session_storage_1.default((_a = this.store) !== null && _a !== void 0 ? _a : this.setStorage)
            : undefined;
        this.isFeatureFlagStatusSet = undefined;
    }
    getItem(key) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.isClientEnabled()) {
                if ((_a = this.storage) === null || _a === void 0 ? void 0 : _a.get(key)) {
                    return this.storage.get(key);
                }
                const response = yield this.preferenceHttpAdapter.getPreference(key);
                const data = this.preferenceParser.toObject(response);
                (_b = this.storage) === null || _b === void 0 ? void 0 : _b.set(key, data);
                return data;
            }
            else {
                return null;
            }
        });
    }
    setItem(key, preferenceValue) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.isClientEnabled()) {
                const preferenceValueArray = yield this.preferenceParser.toArray(preferenceValue);
                const response = yield this.preferenceHttpAdapter.setPreference(key, preferenceValueArray);
                const updatedPreference = this.preferenceParser.toObject(response);
                (_a = this.storage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
                (_b = this.storage) === null || _b === void 0 ? void 0 : _b.set(key, updatedPreference);
                return updatedPreference;
            }
            else {
                return null;
            }
        });
    }
    getItems(prefix) {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.isClientEnabled()) {
                const response = yield this.preferenceHttpAdapter.getPreferences(prefix);
                const userPreferences = this.preferenceParser.toObjectFromList(response);
                return userPreferences;
            }
            else {
                return null;
            }
        });
    }
    isClientEnabled() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isFeatureFlagStatusSet === undefined) {
                this.isFeatureFlagStatusSet = yield this.featureFlags.fetchFeatureFlags(this.config.platform);
            }
            return this.isFeatureFlagStatusSet;
        });
    }
    setUser(user) {
        this.preferenceHttpAdapter.setUser(user);
    }
    setActiveRole(setActiveRole) {
        this.preferenceHttpAdapter.setActiveRole(setActiveRole);
    }
    setLtiBridge(setLtiBridge) {
        this.preferenceHttpAdapter.setLtiBridge(setLtiBridge);
    }
}
exports.PreferenceClient = PreferenceClient;
//# sourceMappingURL=preference-client.js.map